module.exports = __webpack_public_path__ + "img/egud.d1d82c8f.svg";